/* ══════════════════════════════════════════════════════════
   bb2.js — Bracelet Builder v2  italiancharms.fr
   Offre : 10 charms achetés = bracelet offert
====================================================== */
document.addEventListener('DOMContentLoaded', function() {
  'use strict';

  var CFG = window.BB2_CONFIG || {};
  var FREE_SHIP   = CFG.freeShip    || 50;
  var SHIP_COST   = CFG.shipCost    || 7;
  var COLL_HANDLE = CFG.collectionHandle || '';
  var CHARM_TAG   = (CFG.charmTag || '').toLowerCase();
  var CAT_PRODUCT_IDS = CFG.catProductIds || {};
  var COLOR_MAP   = {};
  var TIERS = CFG.tiers || [];
  var TIERS_COMPLETE = CFG.tiersComplete || '\u2728 Tous les paliers d\u00e9bloqu\u00e9s !';
  var BRACELET_FREE_AT = (CFG.braceletFreeAt !== undefined) ? parseInt(CFG.braceletFreeAt, 10) : 10;
  var TXT = CFG.txt || {};
  var T_ADD       = TXT.add        || 'Ajouter';
  var T_ADDED     = TXT.added      || '\u2713 Ajout\u00e9';
  var T_SOLDOUT   = TXT.soldout    || '\u00c9puis\u00e9';
  var T_BFREE     = TXT.braceletFree || '\uD83C\uDF81 Bracelet offert !';
  var T_CHOOSE       = TXT.choose       || 'Choisir';
  var T_VALIDATE     = TXT.validateModal || 'Valider';
  var T_LETTER_TITLE = TXT.letterTitle   || 'Choisis ta lettre';
  var T_MONTH_TITLE   = TXT.monthTitle    || 'Choisis ton mois';
  var T_FREE          = TXT.free          || 'Offert';
  var T_LOADING       = TXT.loading       || 'Ajout en cours...';
  var T_TOTAL         = TXT.total         || 'Total';
  var T_SHIP_FREE     = TXT.shipFree      || '\u2713 Livraison gratuite';
  var T_SHIP_PAID     = TXT.shipPaid      || '+';
  var T_SHIP_SFX      = TXT.shipPaidSuffix|| 'livraison';
  var T_PROG_PREFIX   = TXT.progPrefix    || 'Plus que';
  var T_PROG_SUFFIX   = TXT.progSuffix    || 'pour ton bracelet offert !';
  var T_BRACELET_LBL  = TXT.braceletLabel || 'Bracelet';
  var T_CHARM_LBL     = TXT.charmLabel    || 'Charm';

  try {
    (CFG.colorMap || '').split('\n').forEach(function(line) {
      var parts = line.split(':');
      if (parts.length >= 2) {
        var key = parts[0].trim().toLowerCase();
        var val = parts.slice(1).join(':').trim();
        if (key && val) COLOR_MAP[key] = val;
      }
    });
  } catch(e) {}

  function q(sel, ctx)  { return (ctx||document).querySelector(sel); }
  function qq(sel, ctx) { return Array.from((ctx||document).querySelectorAll(sel)); }
  function on(el, ev, fn) { if (el) el.addEventListener(ev, fn); }
  function norm(s) { return (s||'').toLowerCase().trim(); }
  function fmtCents(c) {
    var n = Math.round(c) / 100;
    try {
      return n.toLocaleString(CFG.locale || 'fr-FR', {
        style: 'currency', currency: CFG.currency || 'EUR',
        minimumFractionDigits: 2, maximumFractionDigits: 2
      });
    } catch(e) {
      return n.toLocaleString('fr-FR', {minimumFractionDigits:2,maximumFractionDigits:2}) + '\u00a0\u20ac';
    }
  }
  function apiPriceToCents(p) {
    var n = parseFloat(p);
    if (isNaN(n)) return 0;
    return n < 100 ? Math.round(n * 100) : Math.round(n);
  }

  var STORAGE_KEY = 'bb2_state_v4';
  var TTL = 7 * 24 * 60 * 60 * 1000;
  var S = { braceletAdded: false, bracelet: null, charms: {}, gifts: [], tool: null };

  /* SWATCH CACHE */
  var SWATCH_STYLE_CACHE = {};
  function collectSwatchStyles() {
    qq('.bb2-charm-swatch[style]').forEach(function(sw) {
      var title = (sw.title || sw.dataset.variantName || '').toLowerCase().trim();
      if (title && !SWATCH_STYLE_CACHE[title]) SWATCH_STYLE_CACHE[title] = sw.getAttribute('style') || '';
    });
  }
  function getSwatchBg(colorName) {
    var key = norm(colorName);
    if (SWATCH_STYLE_CACHE[key]) return SWATCH_STYLE_CACHE[key];
    if (COLOR_MAP[key]) { var v = COLOR_MAP[key]; return 'background:' + v; }
    return 'background:#ccc';
  }

  /* CHARM COUNT + BRACELET FREE */
  function getCharmCount() {
    return Object.keys(S.charms).reduce(function(s,id){ return s + S.charms[id].qty; }, 0);
  }
  function braceletIsFree() {
    return S.braceletAdded && getCharmCount() >= BRACELET_FREE_AT;
  }
  function getRawTotal() {
    var bPrice = (S.braceletAdded && S.bracelet) ? S.bracelet.price : 0;
    var ct = Object.keys(S.charms).reduce(function(s,id){ return s + S.charms[id].price * S.charms[id].qty; }, 0);
    return bPrice + ct;
  }

  /* GIFT SLOTS */
  var giftMode = false;
  var giftSlotIdx = -1;
  function getGiftCount(totalCents) {
    var n = 0;
    TIERS.forEach(function(t) { if (t.gift && totalCents >= t.amount * 100) n += t.gift; });
    return n;
  }
  function enterGiftMode(idx) { giftMode = true; giftSlotIdx = idx; }
  function exitGiftMode()     { giftMode = false; giftSlotIdx = -1; }
  function updateFree() {}
  function getFreeIds() { return {}; }

  function autoFillGiftSlot() {
    var availSlots = getGiftCount(getRawTotal());
    if (availSlots <= 0 || !S.braceletAdded) return;
    while (S.gifts.length < availSlots) S.gifts.push(null);
    var firstEmpty = -1;
    for (var i = 0; i < availSlots; i++) { if (!S.gifts[i]) { firstEmpty = i; break; } }
    if (firstEmpty < 0) return;
    var giftVids = (S.gifts || []).filter(Boolean).map(function(g){ return g.variantId; });
    var candidates = Object.keys(S.charms)
      .filter(function(vid){ return giftVids.indexOf(vid) < 0; })
      .map(function(vid){ return Object.assign({variantId: vid}, S.charms[vid]); })
      .sort(function(a,b){ return a.price - b.price; });
    if (!candidates.length) return;
    var c = candidates[0];
    S.gifts[firstEmpty] = { id: c.variantId, variantId: c.variantId, title: c.title||'', price: 0, img: c.img||'' };
  }

  /* BRACELET */
  var addBtn    = q('#bb2-add-bracelet');


  var giftBanner= q('#bb2-gift-banner');
  var priceEl   = q('#bb2-bracelet-price');
  var swatches  = qq('.bb2-swatch');
  var opts      = qq('.bb2-opt');
  var variantData = [];
  try { var vd = q('#bb2-variant-data'); if (vd) variantData = JSON.parse(vd.textContent.trim()); } catch(e) {}

  var selectedColor = (swatches[0] && swatches[0].dataset.color) || '';
  var selectedOpt   = (opts[0]     && opts[0].dataset.option)    || '';

  function findVariant(color, opt) {
    if (!variantData.length) return null;
    var v = variantData.find(function(v){ return ((!color||v.option1===color)&&(!opt||v.option2===opt))&&v.available; });
    if (!v) v = variantData.find(function(v){ return (!color||v.option1===color)&&(!opt||v.option2===opt); });
    return v || variantData[0];
  }
  function syncVariant() {
    var v = findVariant(selectedColor, selectedOpt);
    if (!v) return;
    S.bracelet = { variantId: String(v.id), price: parseInt(v.price,10), title: v.title||'', color: selectedColor, imgSrc: v.img||'' };
    if (priceEl) priceEl.textContent = fmtCents(S.bracelet.price);
    var img = q('#bb2-bracelet-img'), icon = q('#bb2-bracelet-icon');
    if (img && v.img) { img.src = v.img; img.style.display=''; if(icon) icon.style.display='none'; }
    swatches.forEach(function(sw){ sw.classList.toggle('is-active', sw.dataset.color === selectedColor); });
    var isAvail = v.available !== false;
    if (addBtn) {
      addBtn.disabled = !isAvail && !S.braceletAdded;
      addBtn.style.opacity = (!isAvail && !S.braceletAdded) ? '0.45' : '';
      addBtn.textContent = (!isAvail && !S.braceletAdded) ? T_SOLDOUT : (S.braceletAdded ? T_ADDED : T_ADD);
    }
    if (S.braceletAdded) renderPanel();
  }
  function updateOptAvailability() {
    opts.forEach(function(o) {
      var optVal = o.dataset.option || '';
      var combo = variantData.find(function(v){ return v.option1 === selectedColor && v.option2 === optVal; });
      var avail = combo ? combo.available : true;
      o.classList.toggle('is-soldout', !avail);
      o.style.opacity = avail ? '' : '0.45';
      o.style.cursor  = avail ? '' : 'not-allowed';
      o.title = avail ? '' : T_SOLDOUT;
    });
  }

  swatches.forEach(function(sw) {
    on(sw, 'click', function() {
      if (sw.dataset.available === 'false') return;
      selectedColor = sw.dataset.color || '';
      var lbl = q('#bb2-color-label'); if(lbl) lbl.textContent = selectedColor;
      swatches.forEach(function(s){ s.classList.remove('is-active'); });
      sw.classList.add('is-active');
      syncVariant(); updateOptAvailability();
    });
  });
  opts.forEach(function(o) {
    on(o, 'click', function() {
      var optVal = o.dataset.option || '';
      var combo = variantData.find(function(v){ return v.option1 === selectedColor && v.option2 === optVal; });
      if (combo && !combo.available) return;
      opts.forEach(function(x){ x.classList.remove('is-active'); });
      o.classList.add('is-active'); selectedOpt = optVal;
      var lbl = q('#bb2-opt-label'); if(lbl) lbl.textContent = selectedOpt;
      syncVariant();
    });
  });
  syncVariant(); updateOptAvailability();

  /* ── OUTIL À CHARMS ── */
  var toolBtn = q('#bb2-tool-btn');
  if (toolBtn) {
    var toolAdded = false;
    on(toolBtn, 'click', function() {
      toolAdded = !toolAdded;
      toolBtn.classList.toggle('is-added', toolAdded);
      if (!toolBtn.dataset.originalLabel) toolBtn.dataset.originalLabel = T_ADD;
      toolBtn.textContent = toolAdded ? '\u2713 Ajout\u00e9' : toolBtn.dataset.originalLabel;
      /* Stocker dans S pour ajout au panier */
      if (toolAdded) {
        S.tool = {
          variantId: toolBtn.dataset.variantId,
          price: parseInt(toolBtn.dataset.price, 10),
          title: toolBtn.dataset.title || 'Outil',
          img: toolBtn.dataset.img || ''
        };
      } else {
        S.tool = null;
      }
      renderPanel(); updateSheet(); persist();
    });
  }

  on(addBtn, 'click', function() {
    var cv = findVariant(selectedColor, selectedOpt);
    if (!S.braceletAdded && cv && cv.available === false) return;
    S.braceletAdded = !S.braceletAdded;
    if (S.braceletAdded && cv) S.bracelet = { variantId: String(cv.id), price: parseInt(cv.price,10), title: cv.title||'Bracelet', color: selectedColor, imgSrc: cv.img||'' };
    addBtn.classList.toggle('is-added', S.braceletAdded);
    addBtn.disabled = false; addBtn.style.opacity = '';
    addBtn.textContent = S.braceletAdded ? T_ADDED : T_ADD;
    if (giftBanner) giftBanner.style.display = 'none';
    updateFree(); renderPanel(); updateSheet(); persist();
  });

  /* CHARMS */
  function initCharm(card) {
    if (card.dataset.bb2Init) return;
    card.dataset.bb2Init = '1';

    /* ── Détection produit LETTRE ── */
    var isLetter = (card.dataset.bb2Tags || '').toLowerCase().split(',').some(function(t){ return t.trim() === 'lettre' || t.trim() === 'mois'; });
    if (isLetter) {
      var letterVariants = [];
      /* Cas AJAX : variantes stockées en JSON */
      if (card.dataset.bb2LetterVariants) {
        try { letterVariants = JSON.parse(card.dataset.bb2LetterVariants); } catch(e) {}
      }
      /* Cas Liquid : lire depuis les éléments data-variant dans le DOM */
      if (!letterVariants.length) {
        qq('[data-variant-id]', card).forEach(function(el) {
          var vName = el.dataset.variantName || el.dataset.optionValue || el.title || '';
          if (vName && vName.toLowerCase() !== 'default title') {
            letterVariants.push({
              id: el.dataset.variantId,
              name: vName,
              price: el.dataset.price || card.dataset.bb2Price,
              available: el.dataset.available !== 'false'
            });
          }
        });
      }
      /* Fallback : 1 seule variante */
      if (!letterVariants.length) {
        letterVariants.push({
          id: card.dataset.bb2VariantId,
          name: card.dataset.bb2VariantName || '',
          price: card.dataset.bb2Price,
          available: card.dataset.bb2Available !== 'false'
        });
      }
      /* Bouton trigger : utiliser celui déjà présent ou en créer un */
      var existingTrigger = q('.bb2-letter-trigger', card);
      if (existingTrigger) {
        on(existingTrigger, 'click', function(e) {
          e.preventDefault(); e.stopPropagation();
          openLetterModal(card, letterVariants);
        });
      } else {
        var addBL = q('.bb2-charm__add', card);
        var footerL = q('.bb2-charm__footer', card);
        if (addBL) addBL.style.display = 'none';
        var letterBtn = document.createElement('button');
        letterBtn.className = 'bb2-charm__add bb2-letter-trigger';
        letterBtn.innerHTML = T_CHOOSE + ' <span class="bb2-letter-choice"></span>';
        if (footerL) footerL.appendChild(letterBtn);
        on(letterBtn, 'click', function() { openLetterModal(card, letterVariants); });
      }
      /* Masquer les swatches couleur (inutiles pour lettres) */
      var swatchWrap = q('.bb2-charm__swatches', card);
      if (swatchWrap) swatchWrap.style.display = 'none';

      /* Bouton − : supprimer toutes les lettres, reset carte */
      var minBL = q('.bb2-charm__minus', card);
      var plusBL = q('.bb2-charm__plus', card);
      on(minBL, 'click', function() {
        resetLetterCard(card);
        renderPanel(); updateSheet(); persist();
      });
      /* Bouton + : rouvrir la modale pour ajouter d'autres lettres */
      on(plusBL, 'click', function() { openLetterModal(card, letterVariants); });
      return;
    }

    var activeSw = q('.bb2-charm-swatch.is-active', card);
    if (activeSw) {
      if (activeSw.dataset.variantId)    card.dataset.bb2VariantId    = activeSw.dataset.variantId;
      if (activeSw.dataset.price)        card.dataset.bb2Price         = activeSw.dataset.price;
      if (activeSw.dataset.priceDisplay) card.dataset.bb2PriceDisplay  = activeSw.dataset.priceDisplay;
      if (activeSw.dataset.img)          card.dataset.bb2Image         = activeSw.dataset.img;
      if (activeSw.dataset.available)    card.dataset.bb2Available     = activeSw.dataset.available;
      if (activeSw.dataset.comparePrice !== undefined) card.dataset.bb2ComparePrice = activeSw.dataset.comparePrice || '0';
      if (activeSw.dataset.variantName) {
        var vn = activeSw.dataset.variantName;
        card.dataset.bb2VariantName = (vn && vn.toLowerCase() !== 'default title') ? vn : '';
      }
    }
    var vid0 = card.dataset.bb2LastVid || card.dataset.bb2VariantId;
    if (S.charms[vid0] && S.charms[vid0].qty > 0) {
      card.classList.add('is-added');
      var n0=q('.bb2-charm__n',card),a0=q('.bb2-charm__add',card),q0=q('.bb2-charm__qty',card);
      if(n0) n0.textContent=S.charms[vid0].qty; if(a0) a0.style.display='none'; if(q0) q0.style.display='flex';
    }
    var addB=q('.bb2-charm__add',card), qtyDiv=q('.bb2-charm__qty',card);
    var soldEl=q('.bb2-charm__soldout',card), nEl=q('.bb2-charm__n',card);
    var minB=q('.bb2-charm__minus',card), plusB=q('.bb2-charm__plus',card);

    function getVid()   { return card.dataset.bb2LastVid || card.dataset.bb2VariantId || ''; }
    function getPrice()        { return parseInt(card.dataset.bb2Price        || '0', 10); }
    function getComparePrice() { return parseInt(card.dataset.bb2ComparePrice || '0', 10); }

    function setQty(newQ) {
      var vid = getVid();
      if (newQ <= 0) {
        delete S.charms[vid]; card.classList.remove('is-added');
        if (addB) addB.style.display = card.dataset.bb2Available!=='false' ? '' : 'none';
        if (qtyDiv) qtyDiv.style.display = 'none';
      } else {
        var vname = card.dataset.bb2VariantName || '';
        if (vname.toLowerCase() === 'default title') vname = '';
        var fullTitle = card.dataset.bb2Title || '';
        if (vname) fullTitle = fullTitle + ' \u2014 ' + vname;
        S.charms[vid] = { qty: newQ, price: getPrice(), comparePrice: getComparePrice(), title: fullTitle, img: card.dataset.bb2Image||'' };
        card.classList.add('is-added'); card.dataset.bb2LastVid = vid;
        if (addB) addB.style.display = 'none';
        if (qtyDiv) qtyDiv.style.display = 'flex';
      }
      if (nEl) nEl.textContent = Math.max(0, newQ);
      autoFillGiftSlot();
      updateFree(); renderPanel(); updateSheet(); persist();
    }

    qq('.bb2-charm-swatch', card).forEach(function(sw) {
      on(sw, 'click', function(e) {
        e.preventDefault(); e.stopPropagation();
        var oldVid = card.dataset.bb2LastVid || card.dataset.bb2VariantId;
        if (S.charms[oldVid]) { delete S.charms[oldVid]; card.classList.remove('is-added'); if(addB) addB.style.display=''; if(qtyDiv) qtyDiv.style.display='none'; }
        qq('.bb2-charm-swatch', card).forEach(function(s){ s.classList.remove('is-active'); });
        sw.classList.add('is-active');
        card.dataset.bb2VariantId    = sw.dataset.variantId   || card.dataset.bb2VariantId;
        card.dataset.bb2Price        = sw.dataset.price       || card.dataset.bb2Price;
        card.dataset.bb2PriceDisplay = sw.dataset.priceDisplay|| card.dataset.bb2PriceDisplay;
        card.dataset.bb2Image        = sw.dataset.img         || card.dataset.bb2Image;
        /* Mettre à jour l'image visible dans la carte */
        var cardImg = card.querySelector('.bb2-charm__img-wrap img');
        if (cardImg && card.dataset.bb2Image) cardImg.src = card.dataset.bb2Image;
        card.dataset.bb2LastVid      = sw.dataset.variantId   || card.dataset.bb2VariantId;
        card.dataset.bb2Available    = sw.dataset.available   || 'true';
        card.dataset.bb2ComparePrice = sw.dataset.comparePrice || '0';
        if (sw.dataset.variantName) {
          var swVn = sw.dataset.variantName;
          card.dataset.bb2VariantName = swVn.toLowerCase() === 'default title' ? '' : swVn;
        }
        var isAvail = sw.dataset.available !== 'false';
        var prEl = q('.bb2-charm__price', card);
        if (prEl) prEl.textContent = sw.dataset.priceDisplay || card.dataset.bb2PriceDisplay || '';
        if (addB) addB.style.display = isAvail ? '' : 'none';
        if (qtyDiv) qtyDiv.style.display = (isAvail && card.classList.contains('is-added')) ? 'flex' : 'none';
        if (soldEl) soldEl.style.display = isAvail ? 'none' : '';
        renderPanel(); updateSheet(); persist();
      });
    });

    function selectAsGift() {
      var idx = giftSlotIdx;
      if (idx < 0) return;
      var vid = getVid(); if (!vid) return;
      while (S.gifts.length <= idx) S.gifts.push(null);
      S.gifts[idx] = { id: vid, variantId: vid, title: card.dataset.bb2Title||'', price: 0, img: card.dataset.bb2Image||'' };
      exitGiftMode(); renderPanel(); updateSheet(); persist();
    }
    on(card, 'click', function(e) { if (!giftMode || giftSlotIdx < 0) return; e.preventDefault(); e.stopPropagation(); selectAsGift(); });
    on(addB, 'click', function(e) {
      if (card.dataset.bb2Available === 'false') return;
      if (giftMode && giftSlotIdx >= 0) { e.stopPropagation(); selectAsGift(); return; }
      setQty((S.charms[getVid()]?S.charms[getVid()].qty:0)+1);
    });
    on(minB, 'click', function() { setQty((S.charms[getVid()]?S.charms[getVid()].qty:0)-1); });
    on(plusB,'click', function() { setQty((S.charms[getVid()]?S.charms[getVid()].qty:0)+1); });
  }

  function resetLetterCard(card) {
    card.classList.remove('is-added');
    /* Supprimer TOUTES les clés letter_ liées à ce produit de S.charms */
    var baseImg = card.dataset.bb2Image || '';
    Object.keys(S.charms).forEach(function(k) {
      if (k.startsWith('letter_') && S.charms[k].img === baseImg) delete S.charms[k];
    });
    var addB  = card.querySelector('.bb2-letter-trigger');
    var qtyEl = card.querySelector('.bb2-charm__qty');
    var nEl   = card.querySelector('.bb2-charm__n');
    if (addB)  { addB.style.display = ''; addB.innerHTML = T_CHOOSE + ' <span class="bb2-letter-choice"></span>'; }
    if (qtyEl) qtyEl.style.display = 'none';
    if (nEl)   nEl.textContent     = '0';
  }


  /* ── MODALE LETTRES ── */
  var letterModal = null;
  var letterModalCard = null;
  function createLetterModal() {
    if (letterModal) return;
    letterModal = document.createElement('div');
    letterModal.className = 'bb2-letter-modal';
    letterModal.innerHTML = '<div class="bb2-letter-modal__backdrop"></div>'
      + '<div class="bb2-letter-modal__box">'
      + '<div class="bb2-letter-modal__header">'
      + '<span class="bb2-letter-modal__title" id="bb2-letter-modal-title">'+T_LETTER_TITLE+'</span>'
      + '<button class="bb2-letter-modal__close">×</button></div>'
      + '<div class="bb2-letter-modal__grid" id="bb2-letter-grid"></div>'
      + '</div>';
    document.body.appendChild(letterModal);
    on(letterModal.querySelector('.bb2-letter-modal__backdrop'), 'click', closeLetterModal);
    on(letterModal.querySelector('.bb2-letter-modal__close'), 'click', closeLetterModal);
  }

  /* Sélection multi-lettres : tableau de compteurs par variante */
  var letterSelection = {}; /* variantId -> {count, variant} */

  function openLetterModal(card, variants) {
    createLetterModal();
    letterModalCard = card;
    letterSelection = {};
    /* Adapter le titre et les variantes selon le type */
    var isMois = (card.dataset.bb2Tags || '').toLowerCase().split(',').some(function(t){ return t.trim() === 'mois'; });
    var titleEl = letterModal.querySelector('#bb2-letter-modal-title');
    if (titleEl) titleEl.textContent = isMois ? T_MONTH_TITLE : T_LETTER_TITLE;
    /* Si c'est un produit mois sans variantes définies, générer les 12 mois */
    if (isMois && (!variants || variants.length <= 1 || (variants.length === 1 && !variants[0].name))) {
      var basePrice = (variants && variants[0]) ? variants[0].price : (card.dataset.bb2Price || 0);
      var baseId = (variants && variants[0]) ? variants[0].id : card.dataset.bb2VariantId;
      variants = ['Janvier','Février','Mars','Avril','Mai','Juin','Juillet','Août','Septembre','Octobre','Novembre','Décembre'].map(function(m) {
        return { id: baseId, name: m, price: basePrice, available: true };
      });
    }
    var gridEl = letterModal.querySelector('#bb2-letter-grid');
    gridEl.innerHTML = '';

    variants.forEach(function(v) {
      var wrap = document.createElement('div');
      wrap.className = 'bb2-letter-wrap';

      var btn = document.createElement('button');
      btn.className = 'bb2-letter-btn' + (v.available ? '' : ' is-soldout');
      btn.dataset.vid = String(v.id);
      btn.type = 'button';

      /* Label de la lettre */
      var letterLabel = document.createElement('span');
      letterLabel.className = 'bb2-letter-label';
      letterLabel.textContent = v.name;
      btn.appendChild(letterLabel);

      /* Mini compteur − n + */
      var counterWrap = document.createElement('div');
      counterWrap.className = 'bb2-letter-counter';

      var minusBtn = document.createElement('button');
      minusBtn.className = 'bb2-letter-counter__btn';
      minusBtn.type = 'button';
      minusBtn.textContent = '−';

      var countN = document.createElement('span');
      countN.className = 'bb2-letter-counter__n';
      countN.textContent = '0';

      var plusBtn = document.createElement('button');
      plusBtn.className = 'bb2-letter-counter__btn';
      plusBtn.type = 'button';
      plusBtn.textContent = '+';

      counterWrap.appendChild(minusBtn);
      counterWrap.appendChild(countN);
      counterWrap.appendChild(plusBtn);
      btn.appendChild(counterWrap);
      btn.disabled = !v.available;

      function setCount(n) {
        if (!letterSelection[v.id]) letterSelection[v.id] = { count: 0, variant: v };
        letterSelection[v.id].count = Math.max(0, n);
        countN.textContent = letterSelection[v.id].count;
        if (letterSelection[v.id].count > 0) {
          btn.classList.add('is-selected');
        } else {
          btn.classList.remove('is-selected');
          delete letterSelection[v.id];
        }
        updateLetterValidateBtn();
      }

      /* Clic sur la lettre = +1 */
      on(btn, 'click', function(e) {
        if (!v.available) return;
        if (e.target === minusBtn || e.target === plusBtn) return;
        var cur = letterSelection[v.id] ? letterSelection[v.id].count : 0;
        setCount(cur + 1);
      });
      on(plusBtn, 'click', function(e) {
        e.stopPropagation();
        if (!v.available) return;
        var cur = letterSelection[v.id] ? letterSelection[v.id].count : 0;
        setCount(cur + 1);
      });
      on(minusBtn, 'click', function(e) {
        e.stopPropagation();
        var cur = letterSelection[v.id] ? letterSelection[v.id].count : 0;
        setCount(cur - 1);
      });

      wrap.appendChild(btn);
      gridEl.appendChild(wrap);
    });

    /* Bouton valider */
    var footer = letterModal.querySelector('.bb2-letter-modal__footer');
    if (!footer) {
      footer = document.createElement('div');
      footer.className = 'bb2-letter-modal__footer';
      letterModal.querySelector('.bb2-letter-modal__box').appendChild(footer);
    }
    footer.innerHTML = '';
    var validateBtn = document.createElement('button');
    validateBtn.className = 'bb2-letter-validate';
    validateBtn.textContent = T_VALIDATE;
    validateBtn.id = 'bb2-letter-validate';
    on(validateBtn, 'click', validateLetters);
    footer.appendChild(validateBtn);

    letterModal.classList.toggle('bb2-letter-modal--mois', isMois);
    letterModal.classList.toggle('bb2-letter-modal--mois', isMois);
    letterModal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    updateLetterValidateBtn();
  }

  function updateLetterValidateBtn() {
    var btn = document.getElementById('bb2-letter-validate');
    if (!btn) return;
    var total = Object.keys(letterSelection).reduce(function(s,k){ return s + letterSelection[k].count; }, 0);
    if (total === 0) {
      btn.textContent = 'Valider';
      btn.disabled = true;
    } else {
      btn.textContent = T_VALIDATE + ' (' + total + ')';
      btn.disabled = false;
    }
  }

  function validateLetters() {
    if (!letterModalCard) return;
    var card = letterModalCard;
    var baseTitle = card.dataset.bb2Title || '';
    var baseImg   = card.dataset.bb2Image || '';

    Object.keys(letterSelection).forEach(function(vid) {
      var sel = letterSelection[vid];
      var v = sel.variant;
      var title = baseTitle + ' — ' + v.name;
      /* Clé unique : variantId + lettre pour permettre plusieurs fois la même */
      var key = 'letter_' + vid + '_' + Date.now() + '_' + Math.random().toString(36).slice(2,5);
      S.charms[key] = {
        qty: sel.count,
        price: v.price,
        title: title,
        img: baseImg,
        variantId: String(vid)  /* conserver l'ID réel pour l'ajout au panier */
      };
    });

    /* Marquer la carte comme ajoutée */
    var total = Object.keys(letterSelection).reduce(function(s,k){ return s + letterSelection[k].count; }, 0);
    var letters = Object.keys(letterSelection).map(function(k){ return Array(letterSelection[k].count).fill(letterSelection[k].variant.name); }).reduce(function(a,b){return a.concat(b);},[]);
    card.classList.add('is-added');
    var addB  = card.querySelector('.bb2-letter-trigger');
    var qtyEl = card.querySelector('.bb2-charm__qty');
    var nEl   = card.querySelector('.bb2-charm__n');
    if (addB)  { addB.style.display = 'none'; }
    if (qtyEl) qtyEl.style.display = 'flex';
    if (nEl)   nEl.textContent     = total;

    closeLetterModal();
    autoFillGiftSlot();
    renderPanel(); updateSheet(); persist();
  }

  function closeLetterModal() {
    if (letterModal) letterModal.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function selectLetter() {} /* remplacé par validateLetters */


  /* SEARCH + FILTER */
  var searchInput = q('#bb2-search');
  var searchClear = q('#bb2-search-clear');
  var activeCat = 'tous';
  function runFilter() {
    var term = norm(searchInput ? searchInput.value : '');
    var cards = qq('[data-bb2-charm]'); var visible = 0;
    cards.forEach(function(card) {
      var mSearch = !term || norm(card.dataset.bb2Title||'').includes(term) || norm(card.dataset.bb2Colors||'').includes(term) || norm(card.dataset.bb2Tags||'').includes(term);
      var mCat = true;
      if (activeCat !== 'tous') {
        var pid = parseInt(card.dataset.bb2ProductId || '0', 10);
        var catIds = CAT_PRODUCT_IDS[activeCat];
        if (catIds && catIds.size > 0) mCat = catIds.has(pid);
      }
      var show = mSearch && mCat; card.style.display = show ? '' : 'none'; if (show) visible++;
    });
    var noRes = q('#bb2-no-results'); if (noRes) noRes.style.display = (visible===0&&cards.length>0)?'':'none';
  }
  on(searchInput,'input',function(){ if(searchClear) searchClear.style.display=searchInput.value?'':'none'; runFilter(); });
  on(searchClear,'click',function(){ if(searchInput) searchInput.value=''; if(searchClear) searchClear.style.display='none'; runFilter(); if(searchInput) searchInput.focus(); });

  /* CATEGORIES — avec ordre manuel et pré-chargement */
  var collFetchQueue  = {};
  var CAT_ORDER       = {};   /* handle → [id, id, ...] dans l'ordre manuel */
  var originalOrder   = [];   /* ordre initial de la grille principale */
  var orderCaptured   = false;

  function captureOriginalOrder() {
    if (orderCaptured || !grid) return;
    originalOrder = qq('[data-bb2-charm]', grid).map(function(c){ return parseInt(c.dataset.bb2ProductId, 10); });
    orderCaptured = true;
  }

  function reorderGrid(orderedIds) {
    if (!grid || !orderedIds || !orderedIds.length) return;
    var cards = {};
    qq('[data-bb2-charm]', grid).forEach(function(c){ cards[parseInt(c.dataset.bb2ProductId,10)] = c; });
    /* Trier les cartes selon l'ordre demandé */
    orderedIds.forEach(function(id) {
      if (cards[id]) grid.appendChild(cards[id]);
    });
    /* Cartes non présentes dans l'ordre (pas dans cette collection) : les laisser à la fin */
  }

  function fetchCollectionOrder(handle, callback) {
    if (CAT_ORDER[handle]) { callback(CAT_ORDER[handle]); return; }
    if (collFetchQueue[handle]) { collFetchQueue[handle].push(callback); return; }
    collFetchQueue[handle] = [callback];
    var ids = [];
    (function fetchPage(page) {
      fetch('/collections/' + handle + '/products.json?limit=250&sort_by=manual&page=' + page)
        .then(function(r){ return r.json(); })
        .then(function(data) {
          (data.products||[]).forEach(function(p){ ids.push(parseInt(p.id, 10)); });
          if ((data.products||[]).length === 250) { fetchPage(page+1); }
          else {
            CAT_ORDER[handle] = ids;
            CAT_PRODUCT_IDS[handle] = new Set(ids);
            (collFetchQueue[handle]||[]).forEach(function(cb){ cb(ids); });
            delete collFetchQueue[handle];
          }
        })
        .catch(function(){
          CAT_ORDER[handle] = ids;
          CAT_PRODUCT_IDS[handle] = new Set(ids);
          (collFetchQueue[handle]||[]).forEach(function(cb){ cb(ids); });
          delete collFetchQueue[handle];
        });
    })(1);
  }

  /* Pré-charger toutes les catégories en arrière-plan */
  function preloadAllCategories() {
    captureOriginalOrder();
    qq('.bb2-cat[data-collection]').forEach(function(btn) {
      var handle = (btn.dataset.collection||'').trim();
      if (handle) { fetchCollectionOrder(handle, function(){}); }
    });
  }

  qq('.bb2-cat').forEach(function(btn) {
    on(btn, 'click', function() {
      qq('.bb2-cat').forEach(function(b){ b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      activeCat = norm(btn.dataset.cat||'tous');
      var catHandle = (btn.dataset.collection||'').trim();

      if (activeCat === 'tous') {
        reorderGrid(originalOrder);
        runFilter();
      } else if (catHandle) {
        var capturedCat = activeCat; /* capturer par valeur */
        fetchCollectionOrder(catHandle, function(ids) {
          CAT_PRODUCT_IDS[capturedCat] = new Set(ids);
          if (activeCat === capturedCat) { /* vérifier que la cat est toujours active */
            reorderGrid(ids);
            runFilter();
          }
        });
      }
    });
  });
  var grid = q('.bb2-grid');
  if (grid && window.MutationObserver) new MutationObserver(function(){ qq('[data-bb2-charm]').forEach(initCharm); runFilter(); }).observe(grid,{childList:true,subtree:true});
  runFilter(); collectSwatchStyles();

  /* AJAX CHARMS */
  var ajaxLoading = false;
  function buildAjaxCharmCard(p) {
    var variants=p.variants||[], variant=variants.find(function(v){return v.available;})||variants[0];
    if (!variant) return null;
    var imgSrc='';
    if (variant.featured_image) imgSrc=variant.featured_image.src;
    else if (p.images&&p.images[0]) imgSrc=p.images[0].src;
    if (imgSrc) imgSrc=imgSrc.replace(/(\.[^.]+)$/, '_800x800$1');
    var tags=(p.tags||[]).join(',').toLowerCase();
    var priceCents=apiPriceToCents(variant.price), priceDisplay=fmtCents(priceCents);
    var compareCents = variant.compare_at_price ? apiPriceToCents(variant.compare_at_price) : 0;
    var isSale = compareCents > priceCents;
    var discountPct = isSale ? Math.round((compareCents - priceCents) / compareCents * 100) : 0;
    var priceHtml = isSale
      ? '<s class="bb2-charm__compare">'+fmtCents(compareCents)+'</s>'+priceDisplay
      : priceDisplay;
    var saleBadgeHtml = isSale ? '<span class="bb2-charm__sale-badge">-'+discountPct+'%</span>' : '';
    var colorOptIdx=-1;
    (p.options||[]).forEach(function(opt,i){ var lbl=(opt.name||opt).toLowerCase(); if(lbl.includes('couleur')||lbl.includes('color')) colorOptIdx=i; });
    var swatchesHtml='', colorVals=[];
    if (colorOptIdx>=0 && variants.length>1) {
      var seenColors={};
      variants.forEach(function(v) {
        var colorVal=v['option'+(colorOptIdx+1)]||''; if(seenColors[colorVal]) return; seenColors[colorVal]=true;
        var vPC=apiPriceToCents(v.price), vCmp=v.compare_at_price?apiPriceToCents(v.compare_at_price):0, vImg=v.featured_image?v.featured_image.src.replace(/(\.[^.]+)$/,'_800x800$1'):imgSrc;
        colorVals.push(norm(colorVal));
        swatchesHtml+='<button class="bb2-charm-swatch'+(Object.keys(seenColors).length===1?' is-active':'')+(v.available?'':' is-soldout')+'"'
          +' style="'+getSwatchBg(colorVal)+'" data-variant-id="'+v.id+'" data-price="'+vPC+'" data-price-display="'+fmtCents(vPC)+'"'
          +' data-compare-price="'+vCmp+'" data-img="'+vImg+'" data-available="'+v.available+'" data-variant-name="'+(colorVal).replace(/"/g,'&quot;')+'" title="'+(colorVal).replace(/"/g,'&quot;')+'"></button>';
      });
      if (swatchesHtml) swatchesHtml='<div class="bb2-charm__swatches">'+swatchesHtml+'</div>';
    }
    var productAvailable=variants.some(function(v){return v.available;});
    var isLetterProduct = (p.tags||[]).some(function(t){ return t.toLowerCase().trim() === 'lettre' || t.toLowerCase().trim() === 'mois'; });
    var actionHtml;
    if (isLetterProduct) {
      actionHtml = '<button class="bb2-charm__add bb2-letter-trigger">' + (TXT.choose||'Choisir') + ' <span class="bb2-letter-choice"></span></button>'
        +'<div class="bb2-charm__qty" style="display:none"><button class="bb2-charm__minus">&#8722;</button><span class="bb2-charm__n">0</span><button class="bb2-charm__plus">+</button></div>';
    } else {
      actionHtml='<button class="bb2-charm__add"'+(productAvailable?'':' style="display:none"')+'>'+T_ADD+'</button>'
        +'<div class="bb2-charm__qty" style="display:none"><button class="bb2-charm__minus">&#8722;</button><span class="bb2-charm__n">0</span><button class="bb2-charm__plus">+</button></div>'
        +'<span class="bb2-charm__soldout"'+(productAvailable?' style="display:none"':'')+'>'+T_SOLDOUT+'</span>';
    }
    var div=document.createElement('div'); div.className='bb2-charm';
    div.dataset.bb2Charm=''; div.dataset.bb2ProductId=String(p.id); div.dataset.bb2VariantId=String(variant.id);
    div.dataset.bb2LastVid=String(variant.id); div.dataset.bb2Price=String(priceCents); div.dataset.bb2PriceDisplay=priceDisplay;
    div.dataset.bb2Title=p.title||'';
    var dcv=colorOptIdx>=0?(variant['option'+(colorOptIdx+1)]||''):'';
    div.dataset.bb2VariantName=(dcv&&dcv.toLowerCase()!=='default title')?dcv:'';
    div.dataset.bb2Image=imgSrc; div.dataset.bb2Colors=colorVals.join(','); div.dataset.bb2Tags=tags; div.dataset.bb2Available=String(productAvailable); div.dataset.bb2ComparePrice=String(compareCents);
    if (isLetterProduct) {
      /* Stocker toutes les variantes pour la modale */
      var letterVars = variants.map(function(v){
        return { id:v.id, name:v.option1||v.title||'', price:v.price, available:v.available };
      });
      div.dataset.bb2LetterVariants = JSON.stringify(letterVars);
    }
    if (isLetterProduct) {
      /* Trouver l'option qui contient les lettres (option non-couleur) */
      var letterOptIdx = 0; /* par défaut option1 */
      (p.options||[]).forEach(function(opt,i) {
        var lbl = (opt.name||opt).toLowerCase();
        /* Si l'option n'est pas couleur, c'est probablement les lettres */
        if (!lbl.includes('couleur') && !lbl.includes('color') && !lbl.includes('taille') && !lbl.includes('size')) {
          letterOptIdx = i;
        }
      });
      var letterVars = variants.map(function(v) {
        var optKey = 'option' + (letterOptIdx + 1);
        var name = v[optKey] || v.option1 || v.title || '';
        if (name.toLowerCase() === 'default title') name = '';
        return { id: v.id, name: name, price: apiPriceToCents(v.price), available: v.available };
      }).filter(function(v) { return v.name; });
      div.dataset.bb2LetterVariants = JSON.stringify(letterVars);
    }
    div.innerHTML=saleBadgeHtml+'<a href="/products/'+p.handle+'" class="bb2-charm__img-wrap" tabindex="-1">'
      +(imgSrc?'<img src="'+imgSrc+'" alt="'+(p.title||'').replace(/"/g,'&quot;')+'" loading="lazy" width="400" height="400">':'')
      +'</a><div class="bb2-charm__body"><div class="bb2-charm__name">'+(p.title||'')+'</div>'
      +swatchesHtml+'<div class="bb2-charm__footer"><div class="bb2-charm__price'+(isSale?' bb2-charm__price--sale':'')+'">'+priceHtml+'</div>'+actionHtml+'</div></div>';
    return div;
  }
  function loadAllCharms() {
    if (ajaxLoading||!COLL_HANDLE) return; ajaxLoading=true;
    (function fetchPage(page) {
      fetch('/collections/'+COLL_HANDLE+'/products.json?limit=250&sort_by=manual&page='+page)
        .then(function(r){return r.json();})
        .then(function(data) {
          var products=data.products||[], added=0;
          products.forEach(function(p) {
            try {
              if (CHARM_TAG) { var ptags=(p.tags||[]).map(function(t){return t.toLowerCase();}); if(!ptags.some(function(t){return t.includes(CHARM_TAG);})) return; }
              if (q('[data-bb2-product-id="'+p.id+'"]')) return;
              var card=buildAjaxCharmCard(p); if(card&&grid){initCharm(card);grid.appendChild(card);added++;}
            } catch(e) { console.warn('[BB2] skipped product',p.id,p.title,e.message); }
          });
          if (added>0){collectSwatchStyles();runFilter();}
          if (products.length===250){fetchPage(page+1);}else{ajaxLoading=false;collectSwatchStyles();runFilter();preloadAllCategories();}
        })
        .catch(function(err){ajaxLoading=false;});
    })(1);
  }
  if (COLL_HANDLE) { setTimeout(loadAllCharms, 300); }

  /* PROGRESS BAR */
  var progressWrap=q('#bb2-progress'), progressFill=q('#bb2-progress-fill'), progressText=q('#bb2-progress-text'), progressTiersEl=q('#bb2-progress-tiers');
  var sheetProgressWrap=q('#bb2-progress-sheet'), sheetFillEl=q('#bb2-progress-fill-sheet'), sheetTiersEl=q('#bb2-progress-tiers-sheet'), sheetTextEl=q('#bb2-progress-text-sheet');

  function updateProgress() {
    var count = getCharmCount();
    var pct = Math.min(100, (count / BRACELET_FREE_AT) * 100).toFixed(1) + '%';

    function buildMarker(container) {
      if (!container || container.dataset.built) return;
      container.dataset.built = '1';
      /* Un seul marqueur : le palier bracelet offert */
      var tier = document.createElement('div');
      tier.className = 'bb2-progress__tier'; tier.style.left = '100%'; tier.dataset.amount = BRACELET_FREE_AT;
      var badge = document.createElement('div'); badge.className = 'bb2-progress__tier-badge'; badge.textContent = '\uD83C\uDF81';
      tier.appendChild(badge); container.appendChild(tier);
    }
    function updateMarker(container) {
      if (!container) return;
      qq('.bb2-progress__tier', container).forEach(function(el){ el.classList.toggle('is-reached', count >= BRACELET_FREE_AT); });
    }
    function makeText(el) {
      if (!el) return;
      if (count >= BRACELET_FREE_AT) {
        el.innerHTML = '<span class="prog-reward">' + T_BFREE + '</span>';
      } else {
        var rem = BRACELET_FREE_AT - count;
        el.innerHTML = '<span class="prog-prefix">'+T_PROG_PREFIX+' </span>'
          + '<span class="prog-reward">' + rem + ' charm' + (rem > 1 ? 's' : '') + '</span>'
          + '<span class="prog-prefix"> '+T_PROG_SUFFIX+'</span>';
      }
    }
    if (progressWrap) { progressWrap.style.display='flex'; if(progressFill) progressFill.style.width=pct; buildMarker(progressTiersEl); updateMarker(progressTiersEl); makeText(progressText); }
    if (sheetProgressWrap) { sheetProgressWrap.style.display='flex'; if(sheetFillEl) sheetFillEl.style.width=pct; buildMarker(sheetTiersEl); updateMarker(sheetTiersEl); makeText(sheetTextEl); }
  }

  updateProgress();

  /* PANEL */
  var panelCounter=q('#bb2-pack-count'), itemsList=q('#bb2-items'), emptyHint=q('#bb2-empty-hint');
  var totalRow=q('#bb2-total-row'), totalPrEl=q('#bb2-total-price'), shipNoteEl=q('#bb2-ship-note'), ctaBtn=q('#bb2-cta'), ctaPriceEl=q('#bb2-cta-price');

  function calcTotals() {
    var charmArr=Object.keys(S.charms).map(function(id){return Object.assign({id:id},S.charms[id]);});
    var charmsTot=charmArr.reduce(function(s,c){return s+c.price*c.qty;},0);
    var bPrice=(S.braceletAdded&&S.bracelet)?(braceletIsFree()?0:S.bracelet.price):0;
    var sub=bPrice+charmsTot;
    var shipFree=sub>=FREE_SHIP*100, shipCents=Math.round(SHIP_COST*100);
    return {sub:sub,shipFree:shipFree,shipCents:shipCents,total:sub+(shipFree?0:shipCents),
            totalQ:charmArr.reduce(function(s,c){return s+c.qty;},0),charmArr:charmArr};
  }

  function buildItem(o) {
    var div=document.createElement('div'); div.className='bb2-item'+(o.isFree?' is-free':'');
    div.innerHTML='<div class="bb2-item__thumb">'+(o.img?'<img src="'+o.img+'" alt="" width="36" height="36">':'')+'</div>'
      +'<div class="bb2-item__info"><div class="bb2-item__name">'+o.name+'</div>'+(o.sub?'<div class="bb2-item__sub">'+o.sub+'</div>':'')+'</div>'
      +'<div class="bb2-item__price">'+(o.displayPrice||fmtCents(o.price))+'</div>';
    if (o.onRemove) {
      var btn=document.createElement('button');
      btn.className='bb2-item__remove'; btn.title='Supprimer'; btn.type='button'; btn.textContent='×';
      (function(fn){ btn.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); fn(); }); })(o.onRemove);
      div.appendChild(btn);
    }
    return div;
  }

  function renderGiftSlots(container) { /* désactivé — offre bracelet offert active */ }

  function removeBracelet() {
    S.braceletAdded=false;
    if(addBtn){addBtn.classList.remove('is-added');addBtn.textContent=T_ADD;}
    renderPanel();updateSheet();persist();
  }
  function removeCharm(vid) {
    delete S.charms[vid];
    var card=q('[data-bb2-last-vid="'+vid+'"]');
    if(card){card.classList.remove('is-added');var a=q('.bb2-charm__add',card),qe=q('.bb2-charm__qty',card),ne=q('.bb2-charm__n',card);if(a)a.style.display='';if(qe)qe.style.display='none';if(ne)ne.textContent='0';}
    renderPanel();updateSheet();persist();
  }

  function renderPanel() {
    var t=calcTotals();
    var hasAny=S.braceletAdded||t.totalQ>0||(S.gifts&&S.gifts.some(function(g){return g;}));
    if(panelCounter) panelCounter.textContent=t.totalQ;
    if(itemsList){
      if(emptyHint) emptyHint.style.display=hasAny?'none':'';
      qq('.bb2-item,.bb2-gift-slot',itemsList).forEach(function(el){el.remove();});
      renderGiftSlots(itemsList);
      /* Bracelet */
      if(S.braceletAdded&&S.bracelet){
        var bFree=braceletIsFree();
        itemsList.appendChild(buildItem({
          name:S.bracelet.title||'Bracelet',sub:bFree?T_BFREE:null,
          price:S.bracelet.price,isFree:bFree,img:S.bracelet.imgSrc||'',
          displayPrice:bFree?'<s>'+fmtCents(S.bracelet.price)+'</s>&nbsp;'+T_FREE:fmtCents(S.bracelet.price),
          onRemove:removeBracelet
        }));
      }
      /* Outil */
      if (S.tool && S.tool.variantId) {
        itemsList.appendChild(buildItem({
          name: S.tool.title, sub: null, price: S.tool.price, isFree: false,
          img: S.tool.img, displayPrice: fmtCents(S.tool.price),
          onRemove: function() {
            S.tool = null; toolAdded = false;
            if (toolBtn) { toolBtn.classList.remove('is-added'); toolBtn.textContent = toolBtn.dataset.originalLabel || 'Ajouter'; }
            renderPanel(); updateSheet(); persist();
          }
        }));
      }

      t.charmArr.forEach(function(c){
        itemsList.appendChild(buildItem({
          name:c.title+(c.qty>1?' &#215;'+c.qty:''),sub:null,price:c.price,isFree:false,img:c.img,
          displayPrice:(c.comparePrice&&c.comparePrice>c.price)?('<s class="bb2-item__compare">'+fmtCents(c.comparePrice*c.qty)+'</s> '+fmtCents(c.price*c.qty)):fmtCents(c.price*c.qty),onRemove:(function(vid){return function(){
            /* Pour les lettres : supprimer toutes les clés letter_ */
            var allKeys = Object.keys(S.charms).filter(function(k){ return k === vid || (k.startsWith('letter_') && S.charms[k] && S.charms[k].variantId === vid); });
            allKeys.forEach(function(k){ delete S.charms[k]; });
            /* Reset carte DOM — contour rose + boutons */
            var isLetter = vid.toString().indexOf('letter_') === 0;
            if (!isLetter) {
              var domCard = q('[data-bb2-last-vid="'+vid+'"]') || q('[data-bb2-variant-id="'+vid+'"]');
              if (domCard) {
                domCard.classList.remove('is-added');
                var dA=q('.bb2-charm__add',domCard), dQ=q('.bb2-charm__qty',domCard), dN=q('.bb2-charm__n',domCard);
                if (dA) dA.style.display = domCard.dataset.bb2Available!=='false' ? '' : 'none';
                if (dQ) dQ.style.display = 'none';
                if (dN) dN.textContent = '0';
              }
            }
            /* Reset cartes lettres/mois */
            qq('[data-bb2-charm]').forEach(function(c){
              if (c.querySelector('.bb2-letter-trigger')) {
                var hasLetter = Object.keys(S.charms).some(function(k){ return k.startsWith('letter_') && S.charms[k] && S.charms[k].img === c.dataset.bb2Image; });
                if (!hasLetter) resetLetterCard(c);
              }
            });
            renderPanel(); updateSheet(); persist();
          };})(c.id)
        }));
      });
    }
    if(totalRow){
      totalRow.style.display=hasAny?'':'none';
      if(totalPrEl) totalPrEl.textContent=fmtCents(t.sub);
      if(shipNoteEl){shipNoteEl.textContent=t.shipFree?T_SHIP_FREE:T_SHIP_PAID+' '+fmtCents(t.shipCents)+' '+T_SHIP_SFX;shipNoteEl.className='bb2-ship-note '+(t.shipFree?'bb2-ship-note--free':'bb2-ship-note--paid');}
    }
    if(ctaBtn){ctaBtn.disabled=!hasAny;if(ctaPriceEl)ctaPriceEl.textContent=hasAny?fmtCents(t.total):'';}
    updateProgress();
  }

  /* SHEET MOBILE */
  var sheet=q('#bb2-sheet'), sheetBody=q('#bb2-sheet-body'), sheetToggleBtn=q('#bb2-sheet-toggle');
  var sheetCtaBtn=q('#bb2-sheet-cta'), sheetItemCount=q('#bb2-sheet-item-count'), mobileItemsList=q('#bb2m-items');
  var sheetOpen=false;

  function updateSheet(){
    if(!sheet) return;
    var t=calcTotals();
    var hasAny=S.braceletAdded||t.totalQ>0||(S.gifts&&S.gifts.some(function(g){return g;}));
    if(sheetItemCount){
      var totalItems=(S.braceletAdded?1:0)+t.totalQ;
      if(totalItems>0){
        var bPart=S.braceletAdded?'1 '+T_BRACELET_LBL:'', cPart=t.totalQ>0?t.totalQ+' '+T_CHARM_LBL+(t.totalQ>1?'s':''):'';
        sheetItemCount.textContent='\u00b7 '+[bPart,cPart].filter(Boolean).join(' et ');
      } else { sheetItemCount.textContent=''; }
    }
    if(sheetToggleBtn) sheetToggleBtn.textContent=sheetOpen?'\u25bc':'\u25b2';
    var sheetTotal=q('#bb2-sheet-total'); if(sheetTotal) sheetTotal.textContent=hasAny?fmtCents(t.total):'';
    if(mobileItemsList){
      qq('.bb2-item,.bb2-gift-slot',mobileItemsList).forEach(function(el){el.remove();});
      var mEH=q('.bb2-empty-hint',mobileItemsList); if(mEH) mEH.style.display=hasAny?'none':'';
      renderGiftSlots(mobileItemsList);
      if(S.braceletAdded&&S.bracelet){
        var bFreeM=braceletIsFree();
        mobileItemsList.appendChild(buildItem({
          name:S.bracelet.title||'Bracelet',sub:bFreeM?T_BFREE:null,
          price:S.bracelet.price,isFree:bFreeM,img:S.bracelet.imgSrc||'',
          displayPrice:bFreeM?'<s>'+fmtCents(S.bracelet.price)+'</s>&nbsp;'+T_FREE:fmtCents(S.bracelet.price),
          onRemove:removeBracelet
        }));
      }
      if (S.tool && S.tool.variantId) {
        mobileItemsList.appendChild(buildItem({
          name: S.tool.title, sub: null, price: S.tool.price, isFree: false,
          img: S.tool.img, displayPrice: fmtCents(S.tool.price),
          onRemove: function() {
            S.tool = null; toolAdded = false;
            if (toolBtn) { toolBtn.classList.remove('is-added'); toolBtn.textContent = toolBtn.dataset.originalLabel || 'Ajouter'; }
            renderPanel(); updateSheet(); persist();
          }
        }));
      }
      t.charmArr.forEach(function(c){
        mobileItemsList.appendChild(buildItem({
          name:c.title+(c.qty>1?' &#215;'+c.qty:''),sub:null,price:c.price,isFree:false,img:c.img,
          displayPrice:(c.comparePrice&&c.comparePrice>c.price)?('<s class="bb2-item__compare">'+fmtCents(c.comparePrice*c.qty)+'</s> '+fmtCents(c.price*c.qty)):fmtCents(c.price*c.qty),onRemove:(function(vid){return function(){
            /* Pour les lettres : supprimer toutes les clés letter_ */
            var allKeys = Object.keys(S.charms).filter(function(k){ return k === vid || (k.startsWith('letter_') && S.charms[k] && S.charms[k].variantId === vid); });
            allKeys.forEach(function(k){ delete S.charms[k]; });
            /* Reset carte DOM — contour rose + boutons */
            var isLetter = vid.toString().indexOf('letter_') === 0;
            if (!isLetter) {
              var domCard = q('[data-bb2-last-vid="'+vid+'"]') || q('[data-bb2-variant-id="'+vid+'"]');
              if (domCard) {
                domCard.classList.remove('is-added');
                var dA=q('.bb2-charm__add',domCard), dQ=q('.bb2-charm__qty',domCard), dN=q('.bb2-charm__n',domCard);
                if (dA) dA.style.display = domCard.dataset.bb2Available!=='false' ? '' : 'none';
                if (dQ) dQ.style.display = 'none';
                if (dN) dN.textContent = '0';
              }
            }
            /* Reset cartes lettres/mois */
            qq('[data-bb2-charm]').forEach(function(c){
              if (c.querySelector('.bb2-letter-trigger')) {
                var hasLetter = Object.keys(S.charms).some(function(k){ return k.startsWith('letter_') && S.charms[k] && S.charms[k].img === c.dataset.bb2Image; });
                if (!hasLetter) resetLetterCard(c);
              }
            });
            renderPanel(); updateSheet(); persist();
          };})(c.id)
        }));
      });
    }
  }

  function toggleSheet(){ sheetOpen=!sheetOpen; if(sheetBody) sheetBody.style.display=sheetOpen?'':'none'; if(sheetToggleBtn) sheetToggleBtn.textContent=sheetOpen?'\u25bc':'\u25b2'; }
  var topLine=q('.bb2-sheet__topline');
  on(topLine,'click',toggleSheet);
  on(sheetToggleBtn,'click',function(e){e.stopPropagation();toggleSheet();});

  /* CART */
  function openDrawer(){
    /* Hover theme : cart-drawer#mini-cart */
    var drawerEl = document.getElementById('mini-cart');
    if (drawerEl) {
      /* Essai 1 : méthode open() native du custom element */
      if (typeof drawerEl.open === 'function') { drawerEl.open(); return; }
      /* Essai 2 : attribut open (comme <details>) */
      if ('open' in drawerEl) { drawerEl.open = true; return; }
      /* Essai 3 : classe CSS active utilisée par Hover */
      drawerEl.classList.add('is-open', 'active', 'open');
      document.body.classList.add('drawer-open');
      return;
    }
    /* Fallback : clic sur le bouton panier du header */
    var cartBtn = document.querySelector('[href*="/cart"], [data-cart-toggle], .cart-count-bubble, .js-mini-cart-toggle');
    if (cartBtn) { cartBtn.click(); return; }
    /* Dernier recours : redirection */
    window.location.href = '/cart';
  }
  function refreshHoverCart() {
    /* Rafraîchit le contenu du drawer Hover apres ajout */
    fetch('/cart.js')
      .then(function(r){ return r.json(); })
      .then(function(cart) {
        /* Met a jour le compteur dans le header */
        qq('[data-cart-count], .cart-count, .cart-count-bubble span, .js-cart-count').forEach(function(el){
          el.textContent = cart.item_count;
        });
        /* Demande au drawer de se rafraichir */
        var drawerEl = document.getElementById('mini-cart');
        if (drawerEl) {
          if (typeof drawerEl.renderContents === 'function') { drawerEl.renderContents(cart); return; }
          if (typeof drawerEl.refresh === 'function') { drawerEl.refresh(); return; }
        }
        /* Hover theme : dispatch event pour forcer le refresh */
        document.dispatchEvent(new CustomEvent('cart:refresh', {detail: cart}));
        /* Fallback : recharger le drawer via son endpoint section */
        fetch('/?section_id=mini-cart')
          .then(function(r){ return r.text(); })
          .then(function(html) {
            var tmp = document.createElement('div');
            tmp.innerHTML = html;
            var newDrawer = tmp.querySelector('cart-drawer, #mini-cart');
            if (newDrawer && drawerEl) drawerEl.innerHTML = newDrawer.innerHTML;
          });
      });
  }

  function addToCart(){
    var t = calcTotals();
    var hasAny = S.braceletAdded || t.totalQ > 0;
    if (!hasAny) return;
    if(ctaBtn){ if(!ctaBtn.dataset.originalHtml) ctaBtn.dataset.originalHtml=ctaBtn.innerHTML; ctaBtn.disabled=true; ctaBtn.textContent=T_LOADING; }
    if(sheetCtaBtn){ if(!sheetCtaBtn.dataset.originalHtml) sheetCtaBtn.dataset.originalHtml=sheetCtaBtn.innerHTML; }
    if(sheetCtaBtn) sheetCtaBtn.disabled=true;
    var items=[];
    if(S.braceletAdded&&S.bracelet) items.push({id:S.bracelet.variantId,quantity:1});
    var giftVidSet = new Set((S.gifts||[]).filter(Boolean).map(function(g){ return String(g.variantId); }));
    Object.keys(S.charms).forEach(function(vid){
      var c = S.charms[vid]; if(!c||c.qty<=0) return;
      var realId = String(c.variantId || vid);
      if (giftVidSet.has(realId)) return; /* déjà ajouté comme gift, ne pas doubler */
      items.push({id: realId, quantity: c.qty});
    });
    if (S.tool && S.tool.variantId) items.push({id: S.tool.variantId, quantity: 1});
    (S.gifts||[]).forEach(function(g){ if(g&&g.variantId) items.push({id:g.variantId,quantity:1}); });
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})})
      .then(function(r){return r.json();})
      .then(function(){
        refreshHoverCart();
        openDrawer();
        S={braceletAdded:false,bracelet:null,charms:{},gifts:[]};
        try{localStorage.removeItem(STORAGE_KEY);}catch(e){}
        syncVariant();
        if(addBtn){addBtn.classList.remove('is-added');addBtn.textContent=T_ADD;addBtn.disabled=false;addBtn.style.opacity='';}
        if(toolBtn){ toolAdded=false; toolBtn.classList.remove('is-added'); toolBtn.textContent=toolBtn.dataset.originalLabel||'Ajouter'; }
        S.tool = null;
        qq('[data-bb2-charm]').forEach(function(card){
          card.classList.remove('is-added','is-free');
          var a=q('.bb2-charm__add',card),qe=q('.bb2-charm__qty',card),ne=q('.bb2-charm__n',card);
          if(a)a.style.display='';if(qe)qe.style.display='none';if(ne)ne.textContent='0';
        });
        /* Réinitialise les boutons CTA */
        if(ctaBtn){ ctaBtn.disabled=false; if(ctaBtn.dataset.originalHtml) ctaBtn.innerHTML=ctaBtn.dataset.originalHtml; }
        if(sheetCtaBtn){ sheetCtaBtn.disabled=false; if(sheetCtaBtn.dataset.originalHtml) sheetCtaBtn.innerHTML=sheetCtaBtn.dataset.originalHtml; }
        renderPanel(); updateSheet();
      })
      .catch(function(err){ console.error('[BB2]',err); /* erreur silencieuse en prod */ if(ctaBtn){ctaBtn.disabled=false;renderPanel();} if(sheetCtaBtn) sheetCtaBtn.disabled=false; });
  }
  on(sheetCtaBtn,'click',addToCart);
  on(ctaBtn,'click',addToCart);




  /* STICKY PANEL JS — fallback si CSS sticky bloqué par le thème Hover */
  (function() {
    var panel = document.querySelector('.bb2-panel');
    if (!panel) return;
    var HEADER_H = 80;
    var layout = panel.parentElement;
    function updateSticky() {
      var scrollY = window.scrollY || window.pageYOffset;
      var layoutTop = layout.getBoundingClientRect().top + scrollY;
      var layoutH   = layout.offsetHeight;
      var panelH    = panel.offsetHeight;
      var offset    = Math.max(0, Math.min(scrollY - layoutTop + HEADER_H, layoutH - panelH));
      panel.style.transform = 'translateY(' + offset + 'px)';
    }
    /* Désactiver position:sticky CSS pour laisser JS gérer */
    panel.style.position = 'relative';
    panel.style.top = 'auto';
    window.addEventListener('scroll', updateSticky, { passive: true });
    window.addEventListener('resize', updateSticky, { passive: true });
    updateSticky();
  })();

  /* FILTER BAR KILL */
  function killFilterBar(){
    ['.collection-filter-and-sort','.collection-filter','facet-filters-form','.facets-wrapper','.facets',
     '.collection-utility-bar','.collection__filters','.collection__sort','hover-main-collection'].forEach(function(sel){
      try{document.querySelectorAll(sel).forEach(function(el){if(!el.closest('.bb2')&&el.parentNode)el.parentNode.removeChild(el);});}catch(e){}
    });
  }
  killFilterBar();
  /* Observer léger pour cas où le thème insère la barre après coup */
  if (window.MutationObserver) {
    var killObs = new MutationObserver(function(){ killFilterBar(); });
    killObs.observe(document.body, { childList: true, subtree: false });
    setTimeout(function(){ killObs.disconnect(); }, 3000);
  }

  /* PERSIST */
  function persist(){ try{localStorage.setItem(STORAGE_KEY,JSON.stringify({ts:Date.now(),S:S}));}catch(e){} }
  function restore(){
    try{
      var raw=localStorage.getItem(STORAGE_KEY); if(!raw) return;
      var d=JSON.parse(raw); if(Date.now()-d.ts>TTL){localStorage.removeItem(STORAGE_KEY);return;}
      S=d.S; if(!S.gifts) S.gifts=[];
      if(S.braceletAdded){
        if(addBtn){addBtn.classList.add('is-added');addBtn.textContent=T_ADDED;}
        if(S.bracelet){selectedColor=S.bracelet.color||'';syncVariant();}
      }
      qq('[data-bb2-charm]').forEach(function(card){
        var vid=card.dataset.bb2LastVid||card.dataset.bb2VariantId;
        if(S.charms[vid]&&S.charms[vid].qty>0){
          card.classList.add('is-added');
          var n=q('.bb2-charm__n',card),a=q('.bb2-charm__add',card),qe=q('.bb2-charm__qty',card);
          if(n)n.textContent=S.charms[vid].qty;if(a)a.style.display='none';if(qe)qe.style.display='flex';
        }
      });
      if (!S.tool) S.tool = null;
      if (S.tool && toolBtn) { toolBtn.classList.add('is-added'); toolBtn.textContent = '\u2713 Ajout\u00e9'; }
      updateFree(); renderPanel(); updateSheet();
    }catch(e){}
  }
  restore(); renderPanel(); updateSheet();

});